var map = {
	".": 73105,
	"./": 73105,
	"./DevItem": 65748,
	"./DevItem.jsx": 65748,
	"./DevItem.styled": 24492,
	"./DevItem.styled.jsx": 24492,
	"./DevList": 197,
	"./DevList.jsx": 197,
	"./DevList.styled": 37880,
	"./DevList.styled.jsx": 37880,
	"./DevModal": 24265,
	"./DevModal.jsx": 24265,
	"./DevModal.styled": 21247,
	"./DevModal.styled.jsx": 21247,
	"./Swiper": 44247,
	"./Swiper.jsx": 44247,
	"./SwiperDevModal": 4322,
	"./SwiperDevModal.jsx": 4322,
	"./developers_info": 23697,
	"./developers_info.json": 23697,
	"./images/Alisa.jpg": 12343,
	"./images/Anastasiia.jpg": 85178,
	"./images/Anton.jpg": 62480,
	"./images/Denys.jpg": 27075,
	"./images/Elizabeth.jpg": 71959,
	"./images/Ihor.jpg": 37596,
	"./images/Iryna.jpg": 38351,
	"./images/Kateryna.jpg": 64498,
	"./images/Konstantin.jpg": 4128,
	"./images/Nadiia.jpg": 52442,
	"./images/Serhii.jpg": 93811,
	"./images/Valentyna.jpg": 94085,
	"./index": 73105,
	"./index.js": 73105,
	"./swiper.css": 77909,
	"components/Modals/DevModal": 73105,
	"components/Modals/DevModal/": 73105,
	"components/Modals/DevModal/DevItem": 65748,
	"components/Modals/DevModal/DevItem.jsx": 65748,
	"components/Modals/DevModal/DevItem.styled": 24492,
	"components/Modals/DevModal/DevItem.styled.jsx": 24492,
	"components/Modals/DevModal/DevList": 197,
	"components/Modals/DevModal/DevList.jsx": 197,
	"components/Modals/DevModal/DevList.styled": 37880,
	"components/Modals/DevModal/DevList.styled.jsx": 37880,
	"components/Modals/DevModal/DevModal": 24265,
	"components/Modals/DevModal/DevModal.jsx": 24265,
	"components/Modals/DevModal/DevModal.styled": 21247,
	"components/Modals/DevModal/DevModal.styled.jsx": 21247,
	"components/Modals/DevModal/Swiper": 44247,
	"components/Modals/DevModal/Swiper.jsx": 44247,
	"components/Modals/DevModal/SwiperDevModal": 4322,
	"components/Modals/DevModal/SwiperDevModal.jsx": 4322,
	"components/Modals/DevModal/developers_info": 23697,
	"components/Modals/DevModal/developers_info.json": 23697,
	"components/Modals/DevModal/images/Alisa.jpg": 12343,
	"components/Modals/DevModal/images/Anastasiia.jpg": 85178,
	"components/Modals/DevModal/images/Anton.jpg": 62480,
	"components/Modals/DevModal/images/Denys.jpg": 27075,
	"components/Modals/DevModal/images/Elizabeth.jpg": 71959,
	"components/Modals/DevModal/images/Ihor.jpg": 37596,
	"components/Modals/DevModal/images/Iryna.jpg": 38351,
	"components/Modals/DevModal/images/Kateryna.jpg": 64498,
	"components/Modals/DevModal/images/Konstantin.jpg": 4128,
	"components/Modals/DevModal/images/Nadiia.jpg": 52442,
	"components/Modals/DevModal/images/Serhii.jpg": 93811,
	"components/Modals/DevModal/images/Valentyna.jpg": 94085,
	"components/Modals/DevModal/index": 73105,
	"components/Modals/DevModal/index.js": 73105,
	"components/Modals/DevModal/swiper.css": 77909
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 94869;